import { createAction, props } from '@ngrx/store';
import { WeblinksEntity } from './weblinks.models';

export const initWeblinks = createAction('[Weblinks] Init', props<{ language: string }>());

export const loadWeblinksSuccess = createAction(
  '[Weblinks/API] Load Weblinks Success',
  props<{ weblinks: WeblinksEntity[] }>()
);

export const loadWeblinksFailure = createAction('[Weblinks/API] Load Weblinks Failure', props<{ error: string }>());
